import { useMemo } from "react";
import { FormProvider } from "react-hook-form";
import { isSameDay, parseISO } from "date-fns";
import { AppointmentTimeCard } from "./appointment-slot-card";
import { AppointmentConfirmCard } from "./appointment-confirm-card";
import { useAppointmentDateTime } from "../../hooks/use-appointment-date-time";

export const AppointmentForm = ({
    mode,
    context,
    methods,
    onCancel,
    onSubmit,
    startDate,
    availableDates,
    onMonthChange,
    isPending,
    isLoading,
}) => {
    const isEdit = mode === "edit";

    const initialDate = useMemo(() => new Date(startDate), [startDate]);

    // Handle updating calendar and time slots values
    const { selectedDate, selectedTime, handleDateChange, handleTimeChange } =
        useAppointmentDateTime(methods, initialDate, startDate);

    const availableDaySet = new Set(
        availableDates.map((d) => d.startDate.split(" ")[0]),
    );

    const availableTimes = availableDates.filter((d) =>
        isSameDay(parseISO(d.startDate.replace(" ", "T")), selectedDate),
    );

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
                <AppointmentTimeCard
                    isEdit={isEdit}
                    serviceTitle={context?.serviceTitle}
                    handleDateChange={handleDateChange}
                    selectedDate={selectedDate}
                    handleTimeChange={handleTimeChange}
                    selectedTime={selectedTime}
                    availableDaySet={availableDaySet}
                    availableTimes={availableTimes}
                    onMonthChange={onMonthChange}
                    isLoading={isLoading}
                />

                <AppointmentConfirmCard
                    isEdit={isEdit}
                    onCancel={onCancel}
                    isPending={isPending}
                />
            </form>
        </FormProvider>
    );
};
